module.exports = __webpack_public_path__ + "static/img/CorpMessenger.cbeb18f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/CorpMessenger.png
// module id = 1461
// module chunks = 2